export const LIFE_TIME_TOKEN = 3 * 60 * 60 * 1000; // 3 hours
